// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import React, { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx"; // Ensure this function is properly implemented
import TalkToSalesPop from "./TalktosalesPop";
import { sendMailToSales } from "../../services/mail.service";
import ImageSlider from "../slider/ImageSlider";
import { hideChatbotPop, hideIframePop, setActiveDashboard } from "../../store/auth/action";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { logAmplitudeEvent } from "../../utils/amplitude/functions";
import amplitude from "../../utils/amplitude/initiate";
import { useParams } from "react-router-dom";
import { getSession } from "../../utils/sessionstore";
function SalesPopup({ content , target="Banner section" }) {
  const {
    clientname,
    userDetails
  } = useSelector((state) => ({
    clientname: state.clientname,
    userDetails: state.userDetails
  }));
  const { clientID } = useParams();
  const [talkToSalesSuccess, setTalkToSalesSuccess] = useState(false);
  const dispatch = useDispatch();

  function formatDateToMMDDYYYY() {
    const currentDate = new Date();
    return `${String(currentDate.getMonth() + 1).padStart(2, "0")}-${String(
      currentDate.getDate()
    ).padStart(2, "0")}-${currentDate.getFullYear()}`;
  }

  function createEmailSubject() {
    return `User interested in ${content?.heading}`;
  }

  function createEmailBody() {
    const formattedDate = formatDateToMMDDYYYY();
    return `"${userDetails?.firstName} ${userDetails?.lastName}" (${userDetails?.email}) from “${clientname}” has shown interest in ${content?.heading} by clicking on the ${target} on date – “${formattedDate}” (mm-dd-yyyy)`;
  }

  async function onContactSales() {
    try {
      setTalkToSalesSuccess(true);
      const subject = createEmailSubject();
      const body = createEmailBody();
      const payload = {
        userEmail: userDetails?.email,
        message: body,
        subject: subject,
        senderName: userDetails?.firstName,
        clientName: clientname,
      };
      const mailReceipt = await sendMailToSales(payload);
      logAmplitudeEvent(amplitude, "Interested in Dashboard", { triggerType: "SALES_CONTENT", dashboardName: content?.heading, clientId: clientID ?? getSession("client_id"), clientName: clientname, targetType: "Email" ,eventTimestamp:new Date().toLocaleString('en-US', { timeZone: 'UTC' })});
    } catch (err) {
      // dispatch(invokeError(err.message));
      console.log(err);
    }
  }

  function onClose() {
    dispatch(setActiveDashboard({}));
    dispatch(hideIframePop());
    dispatch(hideChatbotPop());
  }

  return (
    <div className="absolute z-40 left-0 top-0 right-0 bottom-0 overflow-y-hidden p-8 bg-[rgba(0,0,0,0.5)] flex items-center justify-center">
      <div className="bg-[#ffffff] w-[80%] h-max flex flex-col shadow" id="modal">
        <div className="flex Roboto flex-row justify-end items-center p-4">
          <div onClick={onClose} className="cursor-pointer">
            <RxCross1 />
          </div>
        </div>
        <div className="w-full h-max flex flex-row px-12 pb-[48px] gap-4">
          <div className="w-1/2 flex flex-col gap-4 justify-start">
            <p className="text-[#5C276E] font-bold text-xl leading-normal text-left">
              {content.heading}
            </p>
            <p className="text-xs Roboto text-[#393B3C] text-left">
              {content.description}
            </p>
            <p className="text-xs Roboto font-[600] text-black text-left ">
              {content?.["sub-description"] || ""}
            </p>
            <div className="h-max w-full flex flex-col gap-4">
              {content.features?.map((feature, index) => (
                <div key={index} className="gap-4">
                  <div className="flex flex-row items-start">
                    <img
                      className="scale-50"
                      src="https://hwlobbystorer1.blob.core.windows.net/images/check 1.svg"
                      alt="check"
                    />
                    <div className="flex flex-col gap-1 h-max">
                      <div className="font-semibold text-xs text-left">
                        {feature.split(":")[0]}
                      </div>
                      <div className="text-xs text-left">{feature.split(":")[1]}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <p className="text-xs Roboto italic text-black text-left" >
              {content?.note || ""}
            </p>
            <button
              onClick={onContactSales}
              className="bg-[#FDBC40] border-[#FDBC40] hover:bg-[#ffcb6a] w-1/2 h-max px-6 py-2 mt-4 text-[#333] font-bold text-sm"
            >
              Learn More
            </button>
          </div>
          <div className="w-1/2 flex items-stretch">
            <div className="h-full w-full">
              <ImageSlider imageUrls={content.img || []} />
            </div>
          </div>
        </div>
      </div>
      {talkToSalesSuccess && (
        <TalkToSalesPop
          talktosalessuccess={talkToSalesSuccess}
          setTalkToSalesSuccess={setTalkToSalesSuccess}
        />
      )}
    </div>
  );
}

export default SalesPopup;
